// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AreaListBlock_wrapper__B4mG1","title":"AreaListBlock_title___nc1f","list":"AreaListBlock_list__jIHlH","item":"AreaListBlock_item__2fd_r"};